import React from "react";
import ReactWOW from 'react-wow';
import i18n from 'i18next'

class About extends React.Component {
  render() {
    const msg = this.props.Message;
    return (
      <section id="about">
        <div className="container">
          <div className="title-block">
            <h2>{i18n.t(msg.introduction)}</h2>
          </div>
          <p>{i18n.t(msg.introLi01)}</p>
          <p>{i18n.t(msg.introLi02)}</p>
          <p>{i18n.t(msg.introLi03)}</p>
          {/* Organized */}
          <div className="flex-box">
            {
              msg.introData.map((item, index) => {
                return (
                  <ReactWOW animation="fadeInUp" delay="0.1s" key={index}>
                    <div className="box box-2">
                      <h4>
                        <img src={"images/" + item.image} style={{ width: "40px", marginRight: "12px" }} alt={item.name} />
                        {i18n.t(item.title)}</h4>
                      {i18n.t(item.desc).split('\n').map((item, key) => {
                        return (<p key={key}>{item}</p>);
                      })}
                    </div>
                  </ReactWOW>
                )
              })
            }
          </div>
        </div>
      </section >
    )
  }
}

export default About;